import api from '@/api/index.js'

// Password
const psw = {
  state: {
    updating: false,
    error: null
  },

  mutations: {
    SET_PSW_ERROR: (state, error) => {
      if (!error) {
        state.error = null;
        return
      }

      state.error = error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText;
      state.updating = false;
    },
    SET_PSW_UPDATING: (state, updating) => {
      state.updating = updating
    }
  },

  actions: {
    PasswordChange({commit}, payload) {
      commit('SET_PSW_UPDATING', true);
      commit('SET_PSW_ERROR', null)
      return api.put(`system-accounts/${payload.systemAccountId}/change-password`, payload.data)
        .then((response) => {
          commit('SET_PSW_UPDATING', false)
        })
        .catch((error) => {
          commit('SET_PSW_ERROR', error);
          commit('SET_PSW_UPDATING', false);
        })
    },
    PasswordForgot({commit}, payload) {
      commit('SET_PSW_UPDATING', true);
      commit('SET_PSW_ERROR', null)
      return api.post('o/auth/forgot-password', payload)
        .then((response) => {
          commit('SET_PSW_UPDATING', false)
        })
        .catch((error) => {
          commit('SET_PSW_ERROR', error);
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText);
          commit('SET_PSW_UPDATING', false);
        })
    },
  }
}

export default psw
